import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core';
import { environment } from '@app/environment';

@Component({
  selector: 'app-unauthenticated',
  templateUrl: './unauthenticated.component.html',
  styleUrls: ['./unauthenticated.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UnauthenticatedComponent {
  private changeDetector = inject(ChangeDetectorRef);
  private auth = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public readonly logo = environment.branding.logo.onLight;
  public readonly appName = environment.branding.appName;
  public credentialsValid = true;
  public showUpdatePassword = false;

  public user = environment.creadentials?.usr || '';
  public pass = environment.creadentials?.pwd || '';

  /** The page that sent the user here (only paths inside the app), else home. */
  private get target(): string {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    return returnUrl &&
      returnUrl.startsWith('/') &&
      !returnUrl.startsWith('//') &&
      !returnUrl.startsWith('/login')
      ? returnUrl
      : '/home';
  }

  login(event: Event, email: string, password: string) {
    event.preventDefault();
    this.auth.login(email, password).subscribe((success) => {
      this.changeDetector.markForCheck();
      if (this.auth.needPasswordUpdate) {
        this.showUpdatePassword = this.auth.needPasswordUpdate;
      } else {
        this.credentialsValid = success;
        if (success) {
          this.router.navigateByUrl(this.target);
        }
      }
    });
  }

  updatePassword(event: Event, newPassword: string, verifyPassword: string) {
    event.preventDefault();
    this.credentialsValid =
      !!newPassword.length && newPassword === verifyPassword;
    if (this.credentialsValid) {
      this.auth.handleNewPassword(newPassword).subscribe((success) => {
        this.credentialsValid = success;
        this.changeDetector.markForCheck();
        if (success) {
          this.router.navigateByUrl(this.target);
        }
      });
    }
  }
}
